export const DISABLE_DELETE_PASSENGERS = 'DISABLE_DELETE_PASSENGERS'

export default () => ({
  type: DISABLE_DELETE_PASSENGERS,
})
